import * as z from "zod";

const validationSchema = z.object({
  companyId: z.number(),
  name: z.string().min(1, { message: "validation:serviceNameRequired" }),
  price: z.number().min(0, { message: "validation:priceRequired" }),
  currency: z.string().min(1, { message: "validation:currencyRequired" }),
  servicePriceUnitId: z.string().min(0, { message: "validation:paymentFrequencyRequired" }),
});

export const CreateCompanySpecificServiceValidationSchema = validationSchema;
export type CreateCompanySpecificServiceFormInput = z.infer<typeof CreateCompanySpecificServiceValidationSchema>;
